import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "576px",
    bgcolor: "background.paper",
    boxShadow: "24",
    p: 4,
    backgroundColor: "white",
    padding: "25px 30px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100%",
    },
    "& img": {
      marginBlockEnd: "50px",
    },
  },
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(22),
    color: "#000",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  description: {
    fontFamily: "Lato",
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(16),
    color: "#333333",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  button: {
    padding: "8px 24px",
    backgroundColor: "#0344DC",
    border: "1px solid #0344DC",
    borderRadius: "100px",
    fontWeight: 600,
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    color: "white",
    margin: "48px auto",
    "& svg path": {
      fill: "#22D9BB",
    },
    "&:hover": {
      backgroundColor: "#022984",
      color: "white",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  arrowRight: {
    transform: "rotate(180deg)",
    height: 14,
  },
}));
